import { ADMIN_MODULE } from "../constants/account.constants.js";

export const ASTERISK = "*";
export const NON_FLOW_MODULES = [ADMIN_MODULE];
